import styled from 'styled-components';

const TextContainer = styled.div`
	background: var(--bannerTermsConditionsBackground);
`;

const TextInner = styled.p`
	padding: 12px;
	background: var(--bannerTermsConditionsOverlay);
	color: var(--bannerTermsConditionsColor);
	font: var(--bannerTermsConditionsFont);
`;

const DefaultTerms = ({ text }) => {
	return (
		<TextContainer>
			<TextInner>{text}</TextInner>
		</TextContainer>
	);
};

export default DefaultTerms;
